import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { vueAppBaseApi, vueAppPassportDomin } from './constants/variables'
import i18n from '@/i18n'

Vue.prototype.$http = axios
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.withCredentials = true
axios.defaults.baseURL = vueAppBaseApi
axios.defaults.headers.get['Cache-Control'] = 'no-cache'
axios.defaults.headers.get['Pragma'] = 'no-cache'

axios.interceptors.response.use((res) => {
  if (res.data.code === 90012) {
    Vue.prototype.$toast({
      message: i18n.t('common.ErrorRefresh'),
      type: 'error'
    })
  }
  return res
}, (error) => {
  return Promise.reject(error)
})

axios.interceptors.request.use((config) => {
  const cookies = document.cookie.split(';')
  let a
  for (let i = 0; i < cookies.length; i++) {
    if (cookies[i].split('=')[0].trim() === 'csrfSecret') {
      a = cookies[i].split('=')[1].trim()
      config.headers.common['X-CSRF-TOKEN'] = a
      break
    }
  }
  config.headers['Lang'] = i18n.locale
  return config
}, (error) => {
  return Promise.reject(error)
})

const REQUEST_STORE = {
  regist (data) {
    return ajax('regist', 'POST', { data })
  },
  updateUserInfo (data) {
    return ajax('user/update', 'POST', { data })
  },
  sendFeedback (data) {
    return ajax('feedback/create', 'POST', { data })
  },
  questionSubmit (data) {
    return ajax('knowledge/submitQuestion', 'POST', { data })
  },
  addWrongQuestion (data) {
    return ajax('knowledge/addWrongQuestion', 'POST', { data })
  },
  addWrongNote (data) {
    return ajax('knowledge/addWrongNote', 'POST', { data })
  },
  questionInteresting (data) {
    return ajax('knowledge/setQuestionPerspective', 'POST', { data })
  },
  questionUseful (data) {
    return ajax('knowledge/setQuestionPerspective', 'POST', { data })
  },
  questionReportError (data) {
    return ajax('feedback/create', 'POST', { data })
  },
  videoSetVideoComment (data) { // video_id
    return ajax('knowledge/setVideoComment', 'POST', { data })
  },
  videoDelComment (data) { // video_id
    return ajax('knowledge/delComment', 'POST', { data })
  },
  videoSaveVideoProgress (data) { // video_id, progress
    return ajax('knowledge/saveVideoProgress', 'POST', { data })
  },
  updateWorship (data) {
    return ajax('knowledge/worship', 'POST', { data })
  },
  deleteWrongQuestions (data) {
    return ajax('knowledge/delWrongQuestion', 'POST', { data })
  },
  videoTop (data) {
    return ajax('knowledge/setVideoPerspective', 'POST', { data })
  },
  getUpdateLog () {
    return ajax('upgrade/getNewest', 'GET')
  },
  getUserInfo () {
    return ajax('user/getInfo?t=' + new Date().getTime(), 'GET')
  },
  sendEmailToReset (data) {
    return ajax('passport/sendResetPasswordEmail', 'GET', { data })
  },
  logout () {
    return ajax('passport/logout', 'GET')
  },
  questionGetMultiQuestions (data) {
    return ajax('knowledge/getMultiQuestions', 'GET', { data })
  },
  questionGetList (data) { // origin
    return ajax('knowledge/getList', 'GET', { data })
  },
  questionPayForResult (data) { // question_id看解析
    return ajax('knowledge/payForResult', 'GET', { data })
  },
  videoGetCommentList (data) {
    return ajax('knowledge/getCommentList', 'GET', { data })
  },
  videoGetCoursesInfo (data) { // parent
    return ajax('knowledge/getCoursesInfo', 'GET', { data })
  },
  videoGetCourse (data) { // video_id
    return ajax('knowledge/getCourse', 'GET', { data })
  },
  videoGetPlayInfo (data) { // video_id
    return ajax('knowledge/getPlayInfo', 'GET', { data })
  },
  videoGetVideoPlayAuth (data) { // video_id
    return ajax('knowledge/getVideoPlayAuth', 'GET', { data })
  },
  videoGetCommentUserInfo (data) { // video_id
    return ajax('knowledge/getCommentUserInfo', 'GET', { data })
  },
  getSkillTree () {
    return ajax('knowledge/getSkillTree', 'GET')
  },
  getQuestionsCount (data) {
    return ajax('knowledge/getQuestionsCount', 'GET', { data })
  },
  getWeekRanking () {
    return ajax('knowledge/getWeekRanking', 'GET')
  },
  getMyWeekRanking () {
    return ajax('knowledge/getWeekUserRanking', 'GET')
  },
  getWrongQuota () {
    return ajax('knowledge/getWrongQuota', 'GET')
  },
  getSkillTreeWrongCount () {
    return ajax('knowledge/skillTreeWrongCount', 'GET')
  },
  getWrongQuestionList (data) {
    return ajax('knowledge/getWrongQuestionList', 'GET', { data })
  },
  getAnnouncement () {
    return ajax('knowledge/getBulletinBoard', 'GET')
  },
  getLiveCourses (data) {
    return ajax('goods/getList', 'GET', { data })
  },
  getLiveCourseDetail (data) {
    return ajax('goods/getGoods', 'GET', { data })
  },
  createOrder (data) {
    return ajax('charge/create', 'POST', { data })
  },
  queryOrder (data) {
    return ajax('charge/queryOrder', 'GET', { data })
  },
  queryChapters (data) {
    return ajax('charge/queryChapters', 'GET', { data })
  },
  querySameOrder (data) {
    return ajax('charge/buyNow', 'GET', { data })
  },
  addFreeCourse (data) {
    return ajax('usercourse/addFreeCourse', 'POST', { data })
  },
  getWxAuth (data) {
    return ajax('charge/wxAuth', 'POST', { data })
  },
  getWxCode (data) {
    return ajax('charge/wxCode', 'POST', { data })
  },
  getLiveSlide () {
    return ajax('goods/getLivingChapterList', 'GET')
  },
  getMyCourses (data) {
    return ajax('usercourse/myCourses', 'GET', { data })
  },
  getMycourseDetail (data) {
    return ajax('usercourse/myCourse', 'GET', { data })
  },
  getCourseAuth (data) {
    return ajax('usercourse/judgeState', 'GET', { data })
  },
  enterClass (data) {
    return ajax('usercourse/enterClass', 'POST', { data })
  },
  keepAlive (data) {
    return ajax('usercourse/keepAlive', 'POST', { data })
  },
  getOrders (data) {
    return ajax('charge/orders', 'GET', { data })
  },
  cancelOrder (data) {
    return ajax('charge/cancel', 'POST', { data })
  },
  getRefundInfo (data) {
    return ajax('charge/getRefundAmount', 'GET', { data })
  },
  refundOrder (data) {
    return ajax('charge/refund', 'POST', { data })
  },
  liveCreateFeedback (data) {
    return ajax('usercourse/createFeedback', 'POST', { data })
  },
  liveGetFeedback (data) {
    return ajax('usercourse/getFeedback', 'GET', { data })
  },
  // 获取试卷信息
  getExamInfo (data) {
    return ajax('work/getInfo', 'GET', { data })
  },
  // 获取试卷题目列表
  getExamQuestionList (data) {
    return ajax('work/getList', 'GET', { data })
  },
  // 反馈
  feedback (data) {
    return ajax('workFeedback/create', 'POST', { data })
  },
  // 开始考试
  startExam (data) {
    return ajax('work/start', 'GET', { data })
  },
  // 学员报名
  studentSignUp (data) {
    return ajax('userClass/create', 'POST', { data })
  },
  // 提交答案
  submitAnswer (data) {
    return ajax('work/answer', 'POST', { data })
  },
  // 交卷
  submitExam (data) {
    return ajax('work/submit', 'POST', { data })
  },
  // 学员统计
  statistics (data) {
    return ajax('work/statistics', 'GET', { data })
  }

}

export function uploadFile (url, formData) {
  return new Promise((resolve, reject) => {
    axios.post(url, formData, {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      transformRequest: [function (data) {
        return data
      }],
      onUploadProgress: function (e) {
        var percentage = Math.round((e.loaded * 100) / e.total) || 0
        if (percentage < 100) {
          console.log(percentage + '%') // 上传进度
        }
      }
    }).then((res) => {
      if (res.status === 200) {
        resolve(res)
      } else {
        reject(res)
      }
    }, res => {
      reject(res)
    })
  })
}
export function chargeOrder (data) {
  return new Promise((resolve, reject) => {
    axios.post('charge/charge', data, {
      method: 'POST'
    }).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        reject(res)
      }
    }, res => {
      reject(res)
    })
  })
}
const widthOutAuth = ['usercourse/judgeState']
function ajax (url, method, options = { data: {} }) {
  if (options !== undefined) {
    var { params = {}, data = {} } = options.data
  } else {
    params = data = {}
  }
  return new Promise((resolve, reject) => {
    axios({
      url,
      method,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
      data: data
    }).then(res => {
      // API正常返回(status=20x), 是否错误通过有无error判断
      if (res.status === 200) {
        resolve(res)
      } else if (res.status === 401 && !widthOutAuth.includes(url)) {
        window.location = `${vueAppPassportDomin}/Login`
        reject(res)
      } else if (res.status === 403) {
        reject(res)
      } else {
        resolve(res)
      }
    }, res => {
      // API请求异常，一般为Server error 或 network error
      if (res.request.status === 401 && !widthOutAuth.includes(url)) {
        window.location = `${vueAppPassportDomin}/Login`
        reject(res)
      } else if (res.status === 403) {
        reject(res)
      } else {
        reject(res)
      }
      Vue.prototype.$toast({
        message: i18n.t('common.ErrAgain'),
        type: 'error',
        duration: 2000
      })
    })
  })
}
export default REQUEST_STORE
